import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandEmpty, CommandGroup,
  CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { CalendarDays, Users, Wallet, BarChart3, Stethoscope, LayoutDashboard } from "lucide-react";
import { api } from "@/lib/api";

export default function CommandPalette({ open, setOpen }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState({ patients: [], appointments: [] });

  useEffect(() => {
    if (!q || q.length < 2) {
      setResults({ patients: [], appointments: [] });
      return;
    }
    let cancel = false;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/search", { params: { q } });
        if (!cancel) setResults(data);
      } catch { /* noop */ }
    }, 200);
    return () => { cancel = true; clearTimeout(t); };
  }, [q]);

  const go = (path) => { setOpen(false); setQ(""); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput
        data-testid="cmd-k-input"
        placeholder="Buscar pacientes, citas o navegar…"
        value={q}
        onValueChange={setQ}
      />
      <CommandList>
        <CommandEmpty>Sin resultados.</CommandEmpty>
        {results.patients?.length > 0 && (
          <CommandGroup heading="Pacientes">
            {results.patients.map((p) => (
              <CommandItem key={p.id} onSelect={() => go(`/pacientes/${p.id}`)}>
                <Stethoscope className="w-4 h-4 mr-2" />
                <span>{p.name}</span>
                <span className="ml-auto text-xs text-muted-foreground font-mono">{p.phone}</span>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        <CommandGroup heading="Navegación">
          <CommandItem onSelect={() => go("/")}>
            <LayoutDashboard className="w-4 h-4 mr-2" /> Resumen
          </CommandItem>
          <CommandItem onSelect={() => go("/agenda")}>
            <CalendarDays className="w-4 h-4 mr-2" /> Agenda de citas
          </CommandItem>
          <CommandItem onSelect={() => go("/pacientes")}>
            <Users className="w-4 h-4 mr-2" /> Pacientes
          </CommandItem>
          <CommandItem onSelect={() => go("/caja")}>
            <Wallet className="w-4 h-4 mr-2" /> Caja del día
          </CommandItem>
          <CommandItem onSelect={() => go("/reportes")}>
            <BarChart3 className="w-4 h-4 mr-2" /> Reportes
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
